import { render, staticRenderFns } from "./ClientEditEconomicGroupDialog.vue?vue&type=template&id=46a0b2b9"
import script from "./ClientEditEconomicGroupDialog.vue?vue&type=script&lang=js"
export * from "./ClientEditEconomicGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports